import { Tabs } from "antd";
import styles from "./ProfilePreview.module.css";
import styled from "@emotion/styled";
import { useState } from "react";
import Home from "./Home";
import About from "./About";
import Jobs from "./Jobs";
import TechStack from "./TechStack";

const items = [
  {
    key: "Home",
    label: "Home",
  },
  {
    key: "About",
    label: "About",
  },
  {
    key: "Jobs",
    label: "Jobs",
  },
  {
    key: "Tech Stack",
    label: "Tech Stack",
  },
];

const CustomTabs = styled(Tabs)`
  && .ant-tabs-nav-wrap {
    padding-left: 3%;
  }

  && .ant-tabs-nav {
    margin-bottom: 0px;
  }

  && .ant-tabs-tab-btn {
    font-size: 16px !important;
  }

  && .ant-tabs-ink-bar {
    position: absolute;
    background: #1677ff;
    pointer-events: none;
    height: 3px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

const ProfilePreview = ({ data }) => {
  const [selected, setSelected] = useState("Home");

  const onChange = (key) => {
    setSelected(key);
  };

  const TabsData = () => {
    switch (selected) {
      case "Home":
        return <Home data={data} onChange={onChange} />;
      case "About":
        return <About data={data} />;
      case "Jobs":
        return <Jobs data={data} />;
      case "Tech Stack":
        return <TechStack data={data} />;
      default:
        return <Home data={data} onChange={onChange} />;
    }
  };

  return (
    <>
      <div className={styles.content_wrap}>
        <div className={styles.title}>Preview of profile</div>
        <div>
          <img className={styles.banner} src={data.headerImg} alt={"banner"} />
          <img
            className={styles.profile_img}
            src={data.profileImg}
            alt={"profile"}
          />
        </div>
        <div className={styles.details}>
          <div className={styles.name}>{data.name}</div>
          <div className={styles.description}>
            {data.sector}
            {" - "}
            {data.location}
            {" - "}
            {data.employees}
          </div>
          {data.website && <div className={styles.web}>{data.website}</div>}
        </div>
        <CustomTabs activeKey={selected} defaultActiveKey={selected} items={items} onChange={onChange} />
      </div>
      {TabsData()}
    </>
  );
};

export default ProfilePreview;
